const React = require('react');
const DynamicClassButton = require('../../mui/misc/dynamic-class-hoc.jsx')('button');
const shallowCompare = require('react-addons-shallow-compare');
require('./dish-props-option.scss');
const dishIconMian = require('../../../asset/images/dish-icon-mian.svg');
import { getUrlParams } from '../../../helper/common-helper.js';

module.exports = React.createClass({
  displayName: 'DishPropsOption',
  propTypes: {
    id: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    name: React.PropTypes.string.isRequired,
    reprice: React.PropTypes.number.isRequired,
    isChecked: React.PropTypes.bool.isRequired,
    onTouchTap: React.PropTypes.func.isRequired,
    showMemberPriceInfo: React.PropTypes.bool,
  },
  getDefaultProps() {
    return {
      isChecked: false,
    };
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  getCharNumber(name) {
    if (name == null) return 0;
    if (typeof name !== 'string') {
      name += '';
    }
    return name.replace(/[^\x00-\xff]/g, '01').length;
  },
  // 显示限免加料标签
  renderTags(tag){
    const type = sessionStorage.getItem('tagsType');
    // ​只是堂食下的快餐才展示
    if(!type || type ==='WM'){
      return;
    }
    return tag && (
      <div className="free-time"><img src={dishIconMian} /></div>
    )
  },
  render() {
    const { id, name, reprice, memberReprice, isChecked, onTouchTap, showMemberPriceInfo, tag } = this.props;
    // const isShowMemberPrice = showMemberPriceInfo && memberReprice > 0;
    const isShowMemberPrice = showMemberPriceInfo && memberReprice >= 0; // 消除memberReprice为0的影响
   
    
    return (
      <DynamicClassButton className="dish-porps-option" data-id={id} data-reprice={reprice} isChecked={isChecked} onTouchTap={onTouchTap}>
        {this.renderTags(tag)}
        <span className="o-flex dish-porps-layout">
          <span className="name o-flex__fluid">{name}</span>
          {reprice !== 0 ? (
            <span className="extra o-flex__fixed">
              {isShowMemberPrice && (
                <span>
                  {/* {memberReprice > 0 ? '' : '-'} */}
                  {memberReprice >= 0 ? '' : '-'}
                  <span className="price">{Math.abs(memberReprice)}</span>
                </span>
              )}
              <span className={`${!!isShowMemberPrice && 'dish-porps-option-line-thought'}`}>
                {reprice > 0 ? '' : '-'}
                <span className="price">{Math.abs(reprice)}</span>
              </span>
            </span>
          ) : (
            false
          )}
        </span>
      </DynamicClassButton>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/detail/dish-props-option.jsx